module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "integration-logo",
    attrs: {
      "alt": "AKKO Genius",
      "src": require("../../../static/icons/Akko-Genius-Concierge-Logo.png")
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63088166","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/GeniusCPRLogo.vue
// module id = 630
// module chunks = 0